
import { useEffect, useState, useContext, CSSProperties } from "react";
import { DataContext, DataProvier } from "./data/DataContext";
import { BrowserRouter, Route, Switch, useParams } from "react-router-dom";
import useToken from "../../hooks/useToken";
import './Contenido_Seguro_CR.css'
import { usePage, useModal } from './hook';
import { lstPage, siteTitleMain, catSumInsuredDolar, catSumInsuredColones, stepEnum } from './data/MochaData';
import { SiteConfig } from './data/Data';
import {
    ButtonCtrl,
    PagesTitleCtrl,
    LineProgressBar,
    ModalMsgCtrl
} from './components'
import { endPoints } from "../../utils/constanst";
import http from "../../services/http";
import {
    GetResumenRate, BuildCardNum, GetHour, ValidateExpirationDate

} from '../../utils/helpMain';
import Modal from "react-modal";
import { IconWarning, IconSad } from './img'
import {
    BuildDataPolicy, BuildPayment,
    BuildNotificationPol, BuildDataOportunity,
    BuildDataNotificationOportunitySL, BuildNotification, BuildSaveCard, GetFormatMoneyFeePay
} from './data/Help'

const Contenido_Seguro_CR = () => {
    const { loading } = useToken();

    useEffect(() => {
        if (!loading) {
            const preloader: any = document.querySelector(".site-preloader");
            if (preloader) {
                preloader.addEventListener("transitionend", (event: any) => {
                    if (event.propertyName === "opacity") {
                        preloader.parentNode.removeChild(preloader);
                    }
                });
                preloader.classList.add("site-preloader__fade");
            }
        }
    }, [loading]);

    if (loading) return (<></>);
    return (
        <DataProvier loading={loading} >
            <BrowserRouter basename={process.env.PUBLIC_URL}>
                <Switch>
                    <Route exact path="/micrositio/cr/ih/contenido_seguro" component={Layout} />
                </Switch>
            </BrowserRouter>
        </DataProvier>
    );
}

const Layout = ({ location }: IPropsParam) => {
    const { IHContenidoSeguroCR, SetIHContenidoSeguroCR, ChangeHandler, ChangeHandler2 } = useContext(DataContext);
    const page = usePage(SiteConfig.InitPage, lstPage);
    const modalLoading = useModal({ isloading: true } as IModalProps);
    const modalMsg = useModal({ isloading: false } as IModalProps);
    const [modalErrorRate, setModalErrorRate] = useState(false);
    const [modalNoValid, setModalNoValid] = useState(false);
    const [modalErrorPV, setModalErrorPV] = useState(false);


    useEffect(() => {
        GetPlansConfiguration();
    }, [IHContenidoSeguroCR.plan])

    useEffect(() => {
        GetRates();
    }, [IHContenidoSeguroCR.nQuotas])

    useEffect(() => {
        if (ValidData(IHContenidoSeguroCR.province))
            GetDefaultCatalog(endPoints.country('506', IHContenidoSeguroCR.province), 'catCanton');
        else
            SetIHContenidoSeguroCR({ ...IHContenidoSeguroCR, catCanton: [], canton: '', catDistrict: [], district: '', catNeighborhood: [], neighborhood: '' })
    }, [IHContenidoSeguroCR.province])


    useEffect(() => {
        if (ValidData(IHContenidoSeguroCR.canton))
            GetCatalogDisctrict()
        else
            SetIHContenidoSeguroCR({ ...IHContenidoSeguroCR, catDistrict: [], district: '', catNeighborhood: [], neighborhood: '' })
    }, [IHContenidoSeguroCR.canton])

    useEffect(() => {
        if (ValidData(IHContenidoSeguroCR.district))
            GetCatalogNeighborhood()
        else
            SetIHContenidoSeguroCR({ ...IHContenidoSeguroCR, catNeighborhood: [], neighborhood: '' })
    }, [IHContenidoSeguroCR.district])

    const GetDefaultCatalog = (endpoint: string, name: string) => {
        modalLoading.show()
        http(endpoint).get().then(x => {
            SetIHContenidoSeguroCR({ ...IHContenidoSeguroCR, [name]: x })
        }).finally(() => modalLoading.hide())
    }

    const GetCatalogDisctrict = () => {
        modalLoading.setTextLoading('Cargando distrito...');
        http(endPoints.district('506', IHContenidoSeguroCR.province, IHContenidoSeguroCR.canton)).get()
            .then((x) => SetIHContenidoSeguroCR({ ...IHContenidoSeguroCR, catDistrict: x, district: '' }))
            .finally(() => modalLoading.hide())
    }

    const GetCatalogNeighborhood = () => {
        modalLoading.setTextLoading('Cargando distrito...');
        http(endPoints.neighborhood('506', IHContenidoSeguroCR.province, IHContenidoSeguroCR.canton, IHContenidoSeguroCR.district)).get()
            .then((x) => SetIHContenidoSeguroCR({ ...IHContenidoSeguroCR, catNeighborhood: x, neighborhood: '' }))
            .finally(() => modalLoading.hide())
    }

    const SavePersonalData = async (): Promise<void> => {
        try {
            modalLoading.show("Validando correo...");

            await http(endPoints.validateMail).post({
                correo: IHContenidoSeguroCR.mail,
                aplicacion: "MicroCR CS"
            });

            modalLoading.show("Guardando...");
            page.Increment();

            const queryParams = new URLSearchParams(location.search);
            const source = queryParams.get('source');
           

            const dataOportunity = BuildDataOportunity(IHContenidoSeguroCR, source);

            const [oportunityResult, welcomeNotificationResult, catRiesgoResult] = await Promise.allSettled([
                http(endPoints.createOportunityNew).post(dataOportunity),
                http(endPoints.sendNotficationNew).post(BuildNotification(IHContenidoSeguroCR, 'BIENVENIDA')),
                http(endPoints.catalogRiesgo).get()
            ]);

            const numOportunity = oportunityResult.status === "fulfilled"
                ? oportunityResult.value.message
                : "-";

            const createdOportunity = oportunityResult.status === "fulfilled";

            const catRiesgo = catRiesgoResult.status === "fulfilled"
                ? catRiesgoResult.value
                : [];



            SetIHContenidoSeguroCR(({
                ...IHContenidoSeguroCR,
                oportunity: numOportunity,
                createdOportunity,
                catInvalidRequirements: catRiesgo,
                paymentPV: Payment,
                downloadPolicy: DownloadPolicy,
                finish: Finish,
                downloadReceipts: DownloadReceipts,
                viewFinishPage: SendNotificationPolicy,
                source: source
            }));

            const dataNotification = BuildDataNotificationOportunitySL(IHContenidoSeguroCR);
            dataNotification.values = {
                ...dataNotification.values,
                '{{oportunidad}}': numOportunity
            };
            try {
                await http(endPoints.sendNotificatioOportunitySL).post(dataNotification);
            } catch (logError) {
                console.warn('Error al enviar la notificación de oportunidad:', logError);
            }
            page.Increment();

        } catch (error) {
            modalMsg.setTextMsgWithClose("Correo no válido");
        } finally {
            modalLoading.hide();
        }
    };

    const InitPageDataContent = () => {
        modalLoading.show()
        http(endPoints.department(506)).get().then(x => {
            SetIHContenidoSeguroCR({ ...IHContenidoSeguroCR, catProvince: x })
            page.Increment();
        }).finally(() => modalLoading.hide())
    }

    const InitPageDataPersonal2 = async () => {
        modalLoading.show();
        try {
            const [nacionalidadResult, profesionResult, countryResult, bankResult] = await Promise.allSettled([
                http(endPoints.catalog2('nacionalidad')).get(),
                http(endPoints.catalog2('profesion')).get(),
                http(endPoints.catalog2('paises')).get(),
                http(endPoints.banks).get(),
            ]);

            const catNationality: ICatalog[] =
                nacionalidadResult.status === 'fulfilled' ? nacionalidadResult.value : [];
            const catProfession: ICatalog[] =
                profesionResult.status === 'fulfilled' ? profesionResult.value : [];
            const catCountry: ICatalog[] =
                countryResult.status === 'fulfilled' ? countryResult.value : [];
            const catBank: ICatalog[] =
                bankResult.status === 'fulfilled' ? bankResult.value : [];

            SetIHContenidoSeguroCR({
                ...IHContenidoSeguroCR,
                catNationality,
                catProfession,
                catCountry,
                catBank
            });

            page.Increment();
        } finally {
            modalLoading.hide();
        }
    };

    const GetPlansConfiguration = async () => {
        const { plan } = IHContenidoSeguroCR;

        if (!ValidData(plan)) {
            return SetIHContenidoSeguroCR({
                ...IHContenidoSeguroCR,
                nQuotas: '',
                catCuotas: [],
                planSelected: ''
            });
        }

        modalLoading.show();

        try {
            const [
                feesResponse,
                planConfigResponse,
                coveragesResponse,
                cclariesResponse,
            ] = await Promise.all([
                http(endPoints.fees(plan)).get(),
                http(endPoints.configPlan(5, plan)).get(),
                http(endPoints.coverages(plan)).get(),
                http(endPoints.catalogByPlan(plan, 'cclaries')).get(),
            ]);


            const catQuotas = (feesResponse ?? []).map((fee: any) => ({
                text: fee.text,
                value: fee.value,
                text2: fee.description,
            }));

            const catCoverages: Array<ICoveragesExt> = (coveragesResponse?.coverages ?? []).map((cov: ICoverages) => ({
                ...cov,
                type: 'DEFAULT',
                catalog: [] as Array<ICatalog>,
                checked: true,
            }));

            const [firstCclaries] = cclariesResponse ?? [];
            const cactividadIH = firstCclaries
                ? (await http(endPoints.catalogByPlanHab(plan, firstCclaries.value)).get())?.[0]?.value ?? '0'
                : '0';

            SetIHContenidoSeguroCR({
                ...IHContenidoSeguroCR,
                catQuotas,
                planConfig: planConfigResponse ?? {},
                catCoverages,
                lstRateResumen: [],
                nQuotas: '',
                planSelected: '',
                cactividadIH: cactividadIH,
                cclaries: firstCclaries?.value ?? '',
            });
        } catch (error) {
            console.error('Error fetching plan configuration', error);

            SetIHContenidoSeguroCR({
                ...IHContenidoSeguroCR,
                nQuotas: '',
                catCuotas: [],
            });
        } finally {
            modalLoading.hide();
        }
    };



    const GetRates = async () => {
        if (!ValidData(IHContenidoSeguroCR.nQuotas) || !ValidData(IHContenidoSeguroCR.plan)) return;


        let lstSum: Array<ICatalog> = IHContenidoSeguroCR.plan === '594' ? catSumInsuredColones : catSumInsuredDolar;
        let errorRate = false;
        let messageErrorRate = '';

        modalLoading.show('Cargando planes...');

        const lstPromise = lstSum.map(x => {
            const data = {
                TipoBienSA3: x.value,
                coverageIds: "[534,535,536]",
                edad: IHContenidoSeguroCR.age,
                ncuotas: IHContenidoSeguroCR.nQuotas,
                CobSA536: '1'
            };

            return http(endPoints.tarificar(IHContenidoSeguroCR.plan)).post(data);
        });

        try {
            const result = await Promise.allSettled(lstPromise);

            let lst: Array<IRatesResumen> = [];
            let lstRate: Array<IRatesLstVidaCR> = [];

            result.forEach((x: any, index: number) => {
                if (x.status === 'fulfilled') {
                    const rates = x.value;

                    // Obtención del resumen de la tarifa
                    const resumen = GetResumenRate({
                        plan: IHContenidoSeguroCR.planConfig,
                        catQuotas: IHContenidoSeguroCR.catQuotas,
                        idDiscount: 0,
                        lstCoverageExt: IHContenidoSeguroCR.catCoverages,
                        lstRates: rates["rates"] as Array<IRates>,
                        nQuotas: IHContenidoSeguroCR.nQuotas,
                        sumInsured: lstSum[index].value,
                    } as IPropsResumenRate);

                    lst.push(resumen);
                    const rate = { RateLst: rates["rates"] as Array<IRates> } as IRatesLstVidaCR;
                    lstRate.push(rate);
                } else {

                    if (!errorRate) {
                        errorRate = true;
                        messageErrorRate = x.reason;
                    }
                }
            });


            SetIHContenidoSeguroCR({
                ...IHContenidoSeguroCR,
                lstRateResumen: lst,
                lstRate: lstRate,
                errorRate: errorRate,
                messageErrorRate: messageErrorRate,
                planSelected:''
            });


            if (errorRate) {
                setModalErrorRate(true);
            }

        } catch (error) {
            console.error("Error al obtener tarifas:", error);
            SetIHContenidoSeguroCR({
                ...IHContenidoSeguroCR,
                errorRate: true,
                messageErrorRate: "Ocurrió un error al obtener las tarifas.",
            });
            // setModalErrorRate(true);
        } finally {
            modalLoading.hide();
        }
    };

    const CreatePolicy = async () => {
        try {

            modalLoading.show('Validando requisitos...');

            const validations = [
                { type: 'nacionalidad', value: IHContenidoSeguroCR.nationality, code: 'NO_NACIONALIDAD' },
                { type: 'profesion', value: IHContenidoSeguroCR.profession, code: 'NO_PROFESION' }
            ];

            const invalid = validations.find(v => !ValidateRequirements(v.type as typeRisk, v.value));

            if (invalid) {
                try {
                    await http(endPoints.sendNotficationNew)
                        .post(BuildNotification(IHContenidoSeguroCR, invalid.code, true))
                        .finally(() => {
                            setModalNoValid(true);
                            modalLoading.hide();
                        });
                } catch (error) {
                    console.error('Error al enviar la notificación de requisitos no válidos:', error);
                }
                return;
            }

            modalLoading.show('Creando oferta...');

            const response = await http(endPoints.createIncendioHogar).post(BuildDataPolicy(IHContenidoSeguroCR));

            SetIHContenidoSeguroCR({
                ...IHContenidoSeguroCR,
                polizaid: response.id
            });

            try {
                await http(endPoints.updateOportunityLogPolicy(IHContenidoSeguroCR.oportunity, response.id)).get();
            } catch (logError) {
                console.warn('Error al actualizar el log de oportunidad:', logError);
            }


            page.Increment();

        } catch (error) {
            console.error('Error al crear la póliza:', error);
        } finally {
            modalLoading.hide();
        }
    };

    const Payment = async (dataIH: IIHContenidoSeguroCR) => {

        let result = document.querySelector("form") as HTMLFormElement;
        if (result.reportValidity() === false) return;

        const resultado = ValidateExpirationDate(dataIH.cardExpirationDate);
        if (resultado) {
            modalMsg.setTextMsgWithClose(resultado);
            return;
        }

        let idPayment = 0
        const info = {
            cnpoliza: '',
            statusAccount: '',
            transactionId: '',
            codigoAutorizacion: ''
        }

        let isErrorPV = false;

        try {

            modalLoading.show('Procesando pago...');
            const data = BuildPayment(dataIH);

            idPayment = await http(endPoints.paymentPay).post(data);
            modalLoading.show("Emitiendo póliza...");

            const resEmision = await http(endPoints.emissions(data.policyId)).get();

            const dataUpdate = {
                idPayment: idPayment,
                cnpoliza: resEmision.policy
            };

            info.cnpoliza = idPayment.toString();

            modalLoading.show("Actualizando póliza...");

            await http(endPoints.paymentUpdate2).put(dataUpdate);

            modalLoading.show("Aplicando pago...");

            const x = await http(endPoints.paymentApplyPayment(idPayment)).get();

            SetIHContenidoSeguroCR({
                ...dataIH,
                statusAccount: x.estadoCuenta,
                transactionId: x.transactionId,
                cnpoliza: resEmision.policy
            });

            info.cnpoliza = resEmision.policy;
            info.statusAccount = x.estadoCuenta;
            info.codigoAutorizacion = x.codigoAutorizacion
            modalLoading.hide();

        } catch (error) {
        
            modalLoading.hide();
            setModalErrorPV(true);
            isErrorPV = true
            if (error) {
                // try {
                //     await http(endPoints.paymentRevert(idPayment)).get();
                // } catch (revertError) {
                //     console.error("Error al revertir pago:", revertError);
                // }
            }
        }
        if (isErrorPV === false) {
            page.ViewPage(stepEnum.StepAutomaticPayment);
            const dataNot = BuildNotification(dataIH, 'PAGO');
            let date = new Date();
            dataNot.values = {
                ...dataNot.values,
                '{{fechaTransaccion}}': date.toLocaleDateString('es-ES'),
                '{{horaTransaccion}}': GetHour(date),
                '{{poliza}}': info.cnpoliza,
                '{{numeroTarjeta}}': BuildCardNum(dataIH.cardNumber),
                '{{codAutorizacion}}': info.codigoAutorizacion,
                '{{montoPagado}}': GetFormatMoneyFeePay(dataIH),
                'contienerecibo': 'S',
                'estadocuenta': info.statusAccount,
                'nombrereporte': `Recibo de Pago ${info.cnpoliza}`,
            };
            modalLoading.show('Enviando correo...');
            http(endPoints.sendNotficationNew)
                .post(dataNot)
                .finally(() => { modalLoading.hide(); return; })
        }
    }

    const DownloadPolicy = async (id: string) => {
        modalLoading.show('Descargando póliza...');
        try {
            await http(endPoints.descargarPoliza(id)).get();
        } catch (error) {
            console.error('Error al descargar la póliza:', error);
        } finally {
            modalLoading.hide();
        }
    };

    const DownloadReceipts = async (id: string): Promise<void> => {
        modalLoading.show('Descargando recibo...');

        try {
            await http(endPoints.paymentReceipt(id, true)).getWithoutParam();
        } catch (error) {
            console.error('Error al descargar el recibo:', error);
        } finally {
            modalLoading.hide();
        }
    };

    const SendNotificationPolicy = async (data: IIHContenidoSeguroCR): Promise<void> => {
        modalLoading.show('Enviando póliza...');

        try {
            await http(endPoints.sendNotficationNew).post(BuildNotificationPol(data, 'POLIZA'));
        } catch (error) {
            // Opcional: puedes agregar una notificación de error aquí
            console.error('Error enviando la póliza:', error);
        } finally {
            modalLoading.hide();
            page.ViewPage(stepEnum.StepFinish);
        }
    };

    const SaveCard = (): void => {
        if (IHContenidoSeguroCR.acceptSaveCard !== 'S') {
            page.Increment();
            return;
        }

        modalLoading.show('Actualizando datos...');

        http(endPoints.paymentUpdate).post(BuildSaveCard(IHContenidoSeguroCR))
            .catch(() => {
            })
            .finally(() => {
                modalLoading.hide();
                page.Increment();
            });
    };

    const SendNotificationErrorPV = async () => {
        try {
            modalLoading.show('Enviando notificación...');

            const payload = BuildNotification(IHContenidoSeguroCR, 'NO_PAGO', true);
            await http(endPoints.sendNotficationNew).post(payload);

            modalMsg.setTextMsgWithClose("Notificación enviada correctamente.");
        } catch (error) {
            console.error("Error al enviar notificación:", error);
            modalMsg.setTextMsgWithClose("Ocurrió un error al enviar la notificación.");
        } finally {
            setModalNoValid(false);
            modalLoading.hide();
        }
    };

    const ValidateRequirements = (type: typeRisk, value: string): boolean => {
        return !IHContenidoSeguroCR.catInvalidRequirements.some(
            req => req.idMaestro === type.toString() && req.valor.toString() === value.toString()
        );
    };

    const Finish = (): void => {
        const form = document.querySelector("form") as HTMLFormElement | null;

        if (!form) {
            console.warn("Formulario no encontrado");
            return;
        }

        if (!form.reportValidity()) {
            console.info("El formulario no es válido");
            return;
        }

        try {
            modalLoading.show();

            const redirectUrl = 'https://www.lafise.com/slcr/seguros/seguros-individuales/autoexpedible-contenido-seguro/solicitud-recibida';

            if (window.top && window.top !== window.self) {
                // Está dentro de un iframe, pero tiene acceso
                window.top.location.href = redirectUrl;
            } else {
                // En ventana normal
                window.location.href = redirectUrl;
            }
        } catch (error) {
            console.error("Redirección fallida:", error);
        }
    };

    const Back = () => page.Decrement();
    const ValidData = (data: string) => (data !== null && data !== undefined && data !== '')

    const Submit = () => {
        let result = document.querySelector("form") as HTMLFormElement;
        if (result.reportValidity() === false) return;
        switch (page.index) {
            case stepEnum.StepPersonalData: SavePersonalData(); break;
            case stepEnum.StepPlans: InitPageDataContent(); break;
            case stepEnum.StepDataContent: InitPageDataPersonal2(); break;
            case stepEnum.StepPersonalData2: CreatePolicy(); break;
            case stepEnum.StepAutomaticPayment: SaveCard(); break;
            default: page.Increment(); break;
        }
    }

    const styleModal = {
        content: {
            border: "1px solid #E1E1E1",
            borderRadius: '2%',

        }, overlay: {
            backgroundColor: "rgba(255, 255, 255, 0.5)",
        }
    } as Modal.Styles

    return (
        <>
            <div className="container">
                <div className='layout-ih-contenido-cr'>
                    {siteTitleMain[page.index] !== '' &&
                        <>
                            <div className="mt-10">
                                <p className="lbl-title title-1">{siteTitleMain[page.index]}</p>
                                <p className="lbl-title title-2">Con tu póliza de Autoexpedible Contenido Seguro cuentás con el respaldo ante eventos inesperados</p>
                            </div>
                            <LineProgressBar index={page.actualPage.indexBar} totalPages={SiteConfig.TotalPageBar} />
                        </>
                    }
                    <form>
                        <div style={{ display: "flex" }}>
                            <div className="step-container-ih-contenido-cr">
                                <PagesTitleCtrl {...page.actualPage} />
                                {lstPage[page.index].page}
                            </div>
                        </div>
                        <ButtonCtrl data={page.actualPage} submit={Submit} back={Back} />
                    </form>
                </div>
            </div>
            <ModalMsgCtrl {...modalLoading.modal} closeModal={modalLoading.hide} />
            <ModalMsgCtrl {...modalMsg.modal} closeModal={modalMsg.hide} />
            <Modal className="modal" isOpen={modalErrorRate} style={{ overlay: { background: "rgba(255, 255, 255, 1)" } }} preventScroll={false} shouldCloseOnEsc={false} shouldCloseOnOverlayClick={false} >
                <div className="modal-body-info" style={{ textAlign: 'center' }}>
                    <div className="mt-30" style={{ display: 'flex', justifyContent: 'center' }}>
                        <label className="lbl-title" style={{ color: '#FF0000', fontSize: '20px' }}>
                            ¡Ha ocurrido un error!
                        </label>
                    </div>
                    <div className="mt-30" style={{ display: 'flex', justifyContent: 'center' }}>
                        <IconSad />
                    </div>
                    <p className="lbl-input-vida-cr  mt-20 mb-20" style={{ textAlign: 'center', width: '80%', marginLeft: '10%', lineHeight: '20px' }}>
                        {IHContenidoSeguroCR.messageErrorRate}
                    </p>
                </div>

                <div className="modal-footer mb-30">
                    <div>
                        <button className="modal-btn-close" style={{ background: '#EBEBEB', color: '#4D4D4D' }} onClick={(e) => { e.preventDefault(); setModalErrorRate(false) }}>Regresar</button>
                    </div>
                </div>
            </Modal>
            <Modal className="modal" isOpen={modalNoValid} style={styleModal} preventScroll={false} shouldCloseOnEsc={false} shouldCloseOnOverlayClick={false} >

                <div className="modal-body-info" style={{ textAlign: 'justify' }}>
                    <div className="mt-30" style={{ display: 'flex', justifyContent: 'center' }}>
                        <IconWarning />
                    </div>
                    <p className="lbl-input-vida-cr  mt-20 mb-20" style={{ textAlign: 'justify', width: '80%', marginLeft: '10%', lineHeight: '20px' }}>
                        Por el momento no puede continuar con el proceso de emisión de su póliza.
                        Un ejecutivo de <strong>Seguros LAFISE</strong> se comunicará con usted lo antes posible.
                    </p>
                </div>

                <div className="modal-footer mb-30">
                    {<button className="modal-btn-close" style={{ background: '#008866' }} onClick={(e) => { e.preventDefault(); setModalNoValid(false) }}>Cerrar</button>}
                </div>
            </Modal>
            <Modal className="modal" isOpen={modalErrorPV} style={{ overlay: { background: "rgba(255, 255, 255, 1)" } }} preventScroll={false} shouldCloseOnEsc={false} shouldCloseOnOverlayClick={false} >
                <div className="modal-body-info" style={{ textAlign: 'center' }}>
                    <div className="mt-30" style={{ display: 'flex', justifyContent: 'center' }}>
                        <label className="lbl-title" style={{ color: '#FF0000', fontSize: '20px' }}>
                            ¡Ha ocurrido un error!
                        </label>
                    </div>
                    <div className="mt-30" style={{ display: 'flex', justifyContent: 'center' }}>
                        <IconSad />
                    </div>
                    <p className="lbl-input-vida-cr  mt-20 mb-20" style={{ textAlign: 'center', width: '80%', marginLeft: '10%', lineHeight: '20px' }}>
                        No hemos podido procesar su <br /> solicitud, actualice su método de pago <br /> o proporcione otro e inténtelo <br /> nuevamente.
                    </p>
                    <p className="lbl-input-vida-cr  mt-20 mb-20" style={{ textAlign: 'center', width: '80%', marginLeft: '10%', lineHeight: '20px' }}>
                        Si desea que un ejecutivo de Seguro <br /> LAFISE lo contante para continuar con <br /> la gestión via telefónica de clic en <br />
                        <strong> "Contáctenme"</strong>
                    </p>
                </div>

                <div className="modal-footer mb-30">
                    <div>
                        <button className="modal-btn-close" style={{ background: '#EBEBEB', color: '#4D4D4D' }} onClick={(e) => { e.preventDefault(); setModalErrorPV(false) }}>Regresar</button>
                    </div>
                    <div>
                        <button className="modal-btn-close" style={{ background: '#008866' }} onClick={(e) => { e.preventDefault(); setModalErrorPV(false); SendNotificationErrorPV(); }}>Contáctame</button>
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default Contenido_Seguro_CR 